// extracted by mini-css-extract-plugin
export default {"playable":"r8qdi8"};